'use client';
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = EyePasswordShow;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
function EyePasswordShow(props = {}) {
    return ((0, jsx_runtime_1.jsx)(material_1.SvgIcon, { inheritViewBox: true, children: (0, jsx_runtime_1.jsx)("svg", { fill: "none", height: "24", viewBox: "0 0 24 24", width: "24", children: (0, jsx_runtime_1.jsxs)("g", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2", children: [(0, jsx_runtime_1.jsx)("path", { d: "m1 12s4-8 11-8 11 8 11 8" }), (0, jsx_runtime_1.jsx)("path", { d: "m1 12s4 8 11 8 11-8 11-8" }), (0, jsx_runtime_1.jsx)("circle", { cx: "12", cy: "12", r: "3" })] }) }) }));
}
